export const noDatastakeApps = ['tazama', 'admin', 'app'];
export const withHiddenApps = ['tazama'];
export const datastakeApps = ['tif', 'mmt', 'admin', 'tazama'];
